import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import QRCode from 'qrcode';
import { sbpPaymentRequest } from "../../../../../../../dependencies/submitPayment/methods/fps/api";
import { Content } from "../../../../../../../dependencies/getContent/Content";
import { QRCodeStorage } from "./QRCode";
export var initializeQRCode = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var ctn, amount, _yield$sbpPaymentRequ, url, payId, qrCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ctn = _ref.ctn, amount = _ref.amount;
          _context.next = 3;
          return sbpPaymentRequest({
            to: ctn,
            amount: amount,
            createBinding: Content.getInstance().getData().sbpPopup.request.createBinding
          });
        case 3:
          _yield$sbpPaymentRequ = _context.sent;
          url = _yield$sbpPaymentRequ.qrCode;
          payId = _yield$sbpPaymentRequ.payId;
          _context.next = 8;
          return QRCode.toDataURL(url || '');
        case 8:
          qrCode = _context.sent;
          _context.next = 11;
          return QRCodeStorage.getInstance().initialize({
            qrCode: qrCode,
            url: url,
            payId: payId
          });
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initializeQRCode(_x) {
    return _ref2.apply(this, arguments);
  };
}();